var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgReminderSurvey(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 0h24v24H1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c5cee0",
    d: "M4.063 16.846l.147.005a2.072 2.072 0 011.915 2.072l-.005.148A2.069 2.069 0 014.062 21 2.07 2.07 0 012 18.923a2.07 2.07 0 012.063-2.077zm19.25.692c.38 0 .687.31.687.693v1.384a.69.69 0 01-.688.693H9.563a.69.69 0 01-.687-.693v-1.384l.006-.094a.69.69 0 01.682-.599zM4.063 9.923l.147.005A2.072 2.072 0 016.125 12l-.005.148a2.07 2.07 0 01-2.058 1.929A2.07 2.07 0 012 12a2.07 2.07 0 012.063-2.077zm19.25.692c.38 0 .687.31.687.693v1.384a.69.69 0 01-.688.693H9.563a.69.69 0 01-.687-.693v-1.384l.006-.094a.69.69 0 01.682-.599zM4.063 3l.147.005a2.072 2.072 0 011.915 2.072l-.005.148a2.07 2.07 0 01-2.058 1.929A2.07 2.07 0 012 5.077 2.07 2.07 0 014.063 3zm19.25.692c.38 0 .687.31.687.693v1.384a.69.69 0 01-.688.693H9.563a.69.69 0 01-.687-.693V4.385l.006-.094a.69.69 0 01.682-.599z"
  }))));
}

export default SvgReminderSurvey;